/* DON'T EDIT THIS FILE: edit original and run build again */ import { getRealmsByHostAlone } from "../../framework/realm/realm-url.ts";

export const getRealmFromCurrentHostAlone = (
  location: Location,
  configGetter?: () => any
) => getRealmsByHostAlone(configGetter)[location.hostname];
